<ng-template #rt let-r="result" let-t="term">
  {{ r.name }}
</ng-template>
<ng-template #railairtemp let-r="result" let-t="term">
  @if (r.destination; as destination) {
    {{ destination }}{{ r.gateway ? ' (' + r.gateway + ')' : '' }}
  }
</ng-template>
<ng-template #cityRt let-r="result" let-t="term">
  <span> {{ r.name }} ({{ r.countryCode }})</span>
</ng-template>
<ng-template #cityRt1 let-r="result" let-t="term">
  <span [innerHTML]="r.name + ' (' + r.countryCode + ')'"></span>
</ng-template>
<div id="carSearchForm" class="car_search_form">
  <div>
    @if (searchParams?.clonedBasketItemDetails?.identifiers?.makeModel) {
      <div>
        <app-cloned-details
          [name]="searchParams?.clonedBasketItemDetails?.identifiers?.makeModel"
        ></app-cloned-details>
      </div>
    }
    <div class="flex-row-container">
      <mat-radio-group
        class="triple-radio-buttons"
        aria-label="Location selection options"
        (ngModelChange)="
          checkHotelCheckbox($event); searchService.isFavoritesSelected = $event === null
        "
        [(ngModel)]="searchParams.locationType"
      >
        @for (item of searchParams.getLocationTypes() | async; track item) {
          <mat-radio-button
            class="light-primary"
            color="primary"
            id="car-location-type-{{ item | removeSpaces }}"
            [value]="item"
            >{{ item | translate }}
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
    @if (!searchService.isFavoritesSelected) {
      @if (
        (searchParams.locationType === LocationTypes.Postcode ||
          searchParams.locationType === LocationTypes.City) &&
        isEnterpriseCarHire
      ) {
        <div class="flex-row-container">
          <label class="header-label" i18n="@@carDeliveryCollection">Delivery & collection</label>
          <section (mouseleave)="ttDeliveryCollection.close()" class="container">
            <button
              #ttDeliveryCollectionBtn
              type="button"
              class="accessible-tooltip-trigger ico ico-info-circle"
              i18n-ngbTooltip
              ngbTooltip="Please Note: Collection & Delivery is restricted to Enterprise Car Hire only.
              Additional charges may apply for delivery and collection service."
              triggers="manual"
              #ttDeliveryCollection="ngbTooltip"
              (mouseenter)="ttDeliveryCollection.open()"
              (focus)="ttDeliveryCollection.open()"
              (blur)="ttDeliveryCollection.close()"
              (click)="ttDeliveryCollection.toggle()"
              (hidden)="
                ttDeliveryCollectionBtn.setAttribute(
                  'aria-describedby',
                  'car-delivery-collection-tooltip'
                )
              "
              aria-label="Delivery and collection information"
              aria-describedby="car-delivery-collection-tooltip"
            ></button>
            <div class="visuallyhidden" id="car-delivery-collection-tooltip" role="tooltip">
              Please Note: Collection & Delivery is restricted to Enterprise Car Hire only.
              Additional charges may apply for delivery and collection service.
            </div>
          </section>
        </div>
        <div class="flex-row-container delivery-collection-container">
          <mat-checkbox
            class="light-primary"
            color="primary"
            [(ngModel)]="searchParams.delivery"
            (change)="toggleDeliveryCheckbox()"
            i18n="@@carIwantmyrentaldelivered"
            aria-label="I want my rental delivered"
            aria-checked="{{ searchParams.delivery }}"
            >I want my rental delivered</mat-checkbox
          >
          <mat-checkbox
            class="light-primary"
            color="primary"
            [(ngModel)]="searchParams.collection"
            (change)="toggleCollectionCheckbox()"
            i18n="@@carIwantmyrentalcollected"
            aria-label="I want my rental collected"
            aria-checked="{{ searchParams.collection }}"
            >I want my rental collected</mat-checkbox
          >
        </div>
      }
      @if (
        searchParams.locationType === LocationTypes.City ||
        searchParams.locationType === LocationTypes.Postcode
      ) {
        <div class="thirds-container">
          @if (searchParams.locationType === LocationTypes.Postcode) {
            <div class="thirds-block">
              <label
                id="car-search-pickup-country"
                class="header-label"
                for="car-select-pickup-country"
                i18n="@@carSearchCountryAirport"
                >Country</label
              >
              <div class="flex-row-container">
                <i class="ico-marker select-box-icon"></i>
                <select
                  [(ngModel)]="searchParams.pickup_country"
                  aria-labelledby="car-search-pickup-country"
                  appSelect
                  (ngModelChange)="updatePostcodes()"
                  id="car-select-pickup-country"
                >
                  <option disabled value="null" i18n="@@carSearchSelectCountry">
                    Select country
                  </option>
                  @for (country of searchService.countries; track country) {
                    <option [ngValue]="country.cCode">
                      {{ country.cName }}
                    </option>
                  }
                </select>
              </div>
            </div>
          }
          @if (!searchParams.delivery && !searchParams.collection) {
            <div class="thirds-block">
              <label
                id="car-search-option-vendor"
                class="header-label"
                i18n="@@carSearchVendor"
                for="car-select-vendor"
                >Vendor</label
              >
              <select
                appSelect
                [(ngModel)]="searchParams.chosenVendor"
                aria-labelledby="car-search-option-vendor"
                (ngModelChange)="updateLocation()"
                id="car-select-vendor"
              >
                @for (vendor of searchParams.vendors; track vendor) {
                  <option [value]="vendor.code">
                    {{ vendor.name | translate }}
                  </option>
                }
              </select>
            </div>
          }
          <div class="thirds-block">
            <div class="half-container">
              <div class="half-block">
                <label
                  id="car-search-within-distance"
                  class="header-label"
                  i18n="@@carSearchWithinDistance"
                  for="car-within-distance"
                  >Within distance</label
                >
                <select
                  appSelect
                  [noIcon]="true"
                  [border]="true"
                  [(ngModel)]="searchParams.chosenDistance"
                  id="car-within-distance"
                  aria-labelledby="car-search-within-distance"
                  (ngModelChange)="updateLocation()"
                >
                  @for (item of searchParams.withinDistance; track item) {
                    <option [value]="item.value">
                      {{ kmMileCheck | memoize: item.name : usingKm : translateService }}
                    </option>
                  }
                </select>
              </div>
              @if (
                searchParams.delivery ||
                searchParams.collection ||
                !searchParams.hasNonEnterpriseCarAccess
              ) {
                <div class="half-block">
                  <label class="header-label" i18n="@@carSearchDriverAage" for="driver-age"
                    >Driver age</label
                  >
                  <select
                    appSelect
                    [noIcon]="true"
                    [border]="true"
                    [(ngModel)]="searchParams.driverAge"
                    id="driver-age"
                  >
                    @for (age of searchParams.driverAges; track age) {
                      <option [value]="age.value">
                        {{ age.name }}
                      </option>
                    }
                  </select>
                </div>
              }
            </div>
          </div>
          @if (searchParams.locationType === LocationTypes.City) {
            <div class="thirds-block"></div>
          }
        </div>
      }
      <div class="thirds-container">
        @if (searchParams.locationType === LocationTypes.Airport) {
          <div class="thirds-block">
            <label
              id="car-search-pickup-country"
              class="header-label"
              for="car-select-pickup-country"
              i18n="@@carSearchPickupCountryAirport"
              >Pick-up country</label
            >
            <div class="flex-row-container">
              <i class="ico-marker select-box-icon"></i>
              <select
                [(ngModel)]="searchParams.pickup_country"
                aria-labelledby="car-search-pickup-country"
                appSelect
                (change)="onOptionsSelected($event)"
                id="car-select-pickup-country"
              >
                <option disabled value="null" i18n="@@carSearchSelectCountry">
                  Select country
                </option>
                @for (country of searchService.countries; track country) {
                  <option [ngValue]="country.cCode">
                    {{ country.cName }}
                  </option>
                }
              </select>
            </div>
          </div>
          <div class="thirds-block">
            <label
              id="car-search-pickup-location"
              class="header-label"
              for="car-pickup-location"
              i18n="@@carSearchPickupLocationAirport"
              >Pick-up location</label
            >
            <div class="flex-row-container">
              <i class="ico-marker combo-box-icon"></i>
              <input
                i18n-placeholder
                placeholder="Enter pickup location"
                name="pickup_location"
                autocomplete="off"
                type="text"
                id="car-pickup-location"
                appInput
                (selectItem)="selectedPickup('Airport', $event); checkHotelCheckbox()"
                [(ngModel)]="searchParams.pickup_location"
                aria-labelledby="car-search-pickup-location"
                [ngbTypeahead]="pickupLocations"
                [resultTemplate]="railairtemp"
                [inputFormatter]="formatter_rail_air"
                (focus)="focus$.next($event.target.value)"
                (click)="$event.target.select()"
                (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                (keyup.arrowup)="ensureElementIsScrolledTo($event)"
                [hasError]="hasPickupError"
              />
            </div>
          </div>
        }
        @if (searchParams.locationType === LocationTypes.City) {
          <div class="thirds-block">
            <label
              id="car-search-pickup-city"
              class="header-label"
              i18n="@@carSearchPickupCity"
              for="car-input-pickup-city"
              >Pick-up city</label
            >
            <div class="flex-row-container">
              <i class="ico-marker combo-box-icon"></i>
              <input
                i18n-placeholder
                placeholder="Enter pickup city"
                name="pickup_location"
                autocomplete="off"
                type="text"
                id="car-input-pickup-city"
                appInput
                [(ngModel)]="searchParams.cityPickup"
                (ngModelChange)="updateCityPickupDepot($event)"
                (selectItem)="selectedPickup('City', $event)"
                [formControl]="pickupCityControl"
                [ngbTypeahead]="pickupCities"
                [resultTemplate]="cityRt"
                [inputFormatter]="cityFormatter"
                aria-labelledby="car-search-pickup-country"
                (focus)="pickupFocus$.next($event.target.value)"
                (click)="$event.target.select()"
                (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                (keyup.arrowup)="ensureElementIsScrolledTo($event)"
              />
            </div>
          </div>
          <div class="thirds-block">
            <label
              id="car-search-pickup-city-location"
              class="header-label"
              i18n="@@carSearchPickupLocation"
              for="car-city-location"
              >Location</label
            >
            <div class="flex-row-container">
              <select
                appSelect
                [compareWith]="compareDepot"
                (ngModelChange)="selectedPickupDepot('City', $event)"
                [(ngModel)]="searchParams.cityPickupDepot"
                aria-labelledby="car-search-pickup-city-location"
                [disabled]="!cityLocations.hasPickupResults"
                id="car-city-location"
              >
                <option value="null" disabled i18n="@@carSearchSelectLocation">
                  @if (cityLocations.filteredPickupDepots.length === 0) {
                    <span> No location found </span>
                  } @else {
                    Select location
                  }
                </option>
                @for (depot of cityLocations.filteredPickupDepots; track depot) {
                  <option [ngValue]="depot">
                    {{ depot?.vendor }} - {{ depot?.cityName }} - {{ depot?.addressLines[0] }}
                  </option>
                }
              </select>
              @if (cityLocations.pickupLoading) {
                <i class="button_spinner input-loading-spinner-right"></i>
              }
            </div>
          </div>
        }
        @if (searchParams.locationType === LocationTypes.Postcode) {
          <div class="thirds-block">
            <label
              id="car-search-pickup-postcode"
              class="header-label"
              i18n="@@carSearchPostcode"
              for="car-select-postcode"
              >Postcode</label
            >
            <div class="flex-row-container">
              <i class="ico-marker combo-box-icon"></i>
              <input
                name="pickup_location"
                autocomplete="off"
                i18n-placeholder
                placeholder="Enter valid postcode"
                type="text"
                id="car-select-postcode"
                appInput
                [(ngModel)]="searchParams.postcodePickupRaw"
                aria-labelledby="car-search-pickup-postcode"
                (ngModelChange)="changePickupPostcode($event)"
                (selectItem)="selectedPickup('Postcode', $event)"
                [formControl]="pickupPostcodeControl"
                [ngbTypeahead]="pickupPostcodes"
                [resultTemplate]="rt"
                [inputFormatter]="postcodeFormatter"
              />
            </div>
          </div>
          <div class="thirds-block">
            <label
              id="car-search-pickup-postcode-location"
              class="header-label"
              i18n="@@carSearchPostcodeLocation"
              for="car-select-location"
              >Location</label
            >
            <div class="flex-row-container">
              <select
                appSelect
                [compareWith]="compareDepot"
                (ngModelChange)="selectedPickupDepot('Postcode', $event)"
                [(ngModel)]="searchParams.postcodePickup"
                aria-labelledby="car-search-pickup-postcode-location"
                [disabled]="!postcodeLocations.hasPickupResults"
                id="car-select-location"
              >
                <option value="null" disabled i18n="@@carSearchSelectLocation">
                  @if (postcodeLocations.filteredPickupDepots.length === 0) {
                    <span> No location found </span>
                  } @else {
                    Select location
                  }
                </option>
                @for (depot of postcodeLocations.filteredPickupDepots; track depot) {
                  <option [ngValue]="depot">
                    {{ depot?.vendor }} - {{ depot?.cityName }} - {{ depot?.addressLines[0] }}
                  </option>
                }
              </select>
              @if (postcodeLocations.pickupLoading) {
                <i class="button_spinner input-loading-spinner-right"></i>
              }
            </div>
          </div>
        }
        <div class="thirds-block">
          <div
            class="flex-row-container"
            [ngClass]="{
              'error-box': searchParams.validationMessages?.includes(
                'Pickup date/time must be after present date/time'
              )
            }"
          >
            <ngbd-datepicker-i18n>
              <div class="flex-column-container two-third">
                <label
                  class="header-label date-label"
                  for="car-outbound-date"
                  i18n="@@taxiSearchPickupDate"
                  >Pick-up date (DD/MM/YYYY)</label
                >
                <i class="ico-calendar combo-box-icon"></i>

                <app-datepicker
                  [minDate]="searchParams.minDate"
                  [startDate]="searchParams.ngbPickupDate"
                  [model]="searchParams.ngbPickupDate"
                  [from]="searchParams.ngbPickupDate"
                  [to]="searchParams.ngbDropoffDate"
                  (newFrom)="searchParams.ngbPickupDate = $event; checkHotelCheckbox()"
                  (newTo)="searchParams.ngbDropoffDate = $event; checkHotelCheckbox()"
                  [class]="'combo-box'"
                  [componentId]="'car-outbound-date'"
                  (newDate)="searchParams.ngbPickupDate = $event; checkHotelCheckbox()"
                >
                </app-datepicker>
              </div>
              <div class="flex-column-container one-third">
                <label
                  class="header-label"
                  for="car-select-pickup-time"
                  i18n="@@TaxiSearchPickupTime"
                  >Pick-up time</label
                >
                <i class="ico-clock combo-box-icon"></i>
                <select
                  id="car-select-pickup-time"
                  appSelect
                  [(ngModel)]="searchParams.pickupTime"
                  aria-label="Pickup time"
                >
                  @for (time of filterTimeArray(searchParams.timeArray); track time) {
                    <option [ngValue]="time.value">
                      {{ time.display }}
                    </option>
                  }
                </select>
              </div>
            </ngbd-datepicker-i18n>
          </div>
        </div>
      </div>

      <!-- Dropoff  -->
      <div class="thirds-container">
        @if (searchParams.locationType === LocationTypes.City) {
          <div class="thirds-block">
            <label
              id="car-search-dropoff-city"
              class="header-label"
              i18n="@@carSearchDropoffCity"
              for="car-dropoff-city-input"
              >Drop-off city</label
            >
            <div class="flex-row-container">
              <i class="ico-marker select-box-icon"></i>
              <!-- [disabled]="searchService.car.use_pickup_for_dropoff" -->
              <input
                i18n-placeholder
                placeholder="Enter dropoff city"
                name="dropoff_location"
                autocomplete="off"
                type="text"
                id="car-search-dropoff-city"
                appInput
                [(ngModel)]="searchParams.cityDropoff"
                (ngModelChange)="updateCityDropoffDepot($event)"
                [formControl]="dropOffCityControl"
                [ngbTypeahead]="dropOffCities"
                [resultTemplate]="cityRt"
                [inputFormatter]="cityFormatter"
                aria-labelledby="car-search-dropoff-city"
                (focus)="dropoffFocus$.next($event.target.value)"
                (click)="$event.target.select()"
                (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                (keyup.arrowup)="ensureElementIsScrolledTo($event)"
              />
            </div>
          </div>
          <div class="thirds-block">
            <label class="header-label" i18n="@@carSearchLocation" for="car-dropoff-location-select"
              >Location</label
            >
            <div class="flex-row-container">
              <!-- (ngModelChange)='cityDropoffAltered($event)' -->
              <select
                appSelect
                [compareWith]="compareDepot"
                [(ngModel)]="searchParams.cityDropoffDepot"
                [disabled]="!cityLocations.hasDropoffResults"
                aria-labelledby="car-search-dropoff-city-location"
                id="car-dropoff-location-select"
              >
                <option value="null" disabled i18n="@@carSearchSelectLocation">
                  @if (cityLocations.filteredDropoffDepots.length === 0) {
                    <span> No location found </span>
                  } @else {
                    Select location
                  }
                </option>
                @for (depot of cityLocations.filteredDropoffDepots; track depot) {
                  <option [ngValue]="depot">
                    {{ depot?.vendor }} - {{ depot?.cityName }} - {{ depot?.addressLines[0] }}
                  </option>
                }
              </select>
              <span
                id="car-search-dropoff-city-location"
                hidden
                i18n="@@AriaCarSearchCitySropoffLocation"
                >Select Dropoff Location</span
              >
              @if (cityLocations.dropoffLoading) {
                <i class="button_spinner input-loading-spinner-right"></i>
              }
            </div>
          </div>
        }
        @if (searchParams.locationType === LocationTypes.Postcode) {
          <div class="thirds-block">
            <label
              id="car-search-dropoff-postcode"
              class="header-label"
              i18n="@@carSearchDropoffPostcode"
              for="car-search-dropoff-postcode-input"
              >Drop-off postcode</label
            >
            <div class="flex-row-container">
              <i class="ico-marker select-box-icon"></i>
              <input
                placeholder="Enter valid postcode"
                i18n-placeholder
                name="dropoff_location"
                autocomplete="off"
                type="text"
                id="car-search-dropoff-postcode-input"
                appInput
                [value]="postCode"
                [(ngModel)]="searchParams.postcodeDropoffRaw"
                [formControl]="dropOffPostcodeControl"
                aria-labelledby="car-search-dropoff-postcode"
                (ngModelChange)="changeDropoffPostcode($event); checkHotelCheckbox()"
                [formControl]="pickupPostcodeControl"
                [ngbTypeahead]="pickupPostcodes"
                [resultTemplate]="rt"
                [inputFormatter]="postcodeFormatter"
              />
            </div>
          </div>
          <div class="thirds-block">
            <label
              class="header-label"
              i18n="@@carSearchLocationPostcode"
              for="carsearchlocation-input"
              >Location</label
            >
            <div class="flex-row-container">
              <!-- searchService.car.use_pickup_for_dropoff ||  (ngModelChange)='postcodeDropoffAltered()'-->
              <select
                appSelect
                [compareWith]="compareDepot"
                (ngModelChange)="checkHotelCheckbox()"
                [(ngModel)]="searchParams.postcodeDropoff"
                [disabled]="!postcodeLocations.hasDropoffResults"
                aria-labelledby="car-search-dropoff-postcode-location"
                id="carsearchlocation-input"
              >
                <option disabled value="null" i18n="@@carSearchSelectLocation">
                  @if (postcodeLocations.filteredDropoffDepots.length === 0) {
                    <span> No location found </span>
                  } @else {
                    Select location
                  }
                </option>
                @for (depot of postcodeLocations.filteredDropoffDepots; track depot) {
                  <option [ngValue]="depot">
                    {{ depot?.vendor }} - {{ depot?.cityName }} - {{ depot?.addressLines[0] }}
                  </option>
                }
              </select>
              @if (postcodeLocations.dropoffLoading) {
                <i class="button_spinner input-loading-spinner-right"></i>
              }
              <span
                id="car-search-dropoff-postcode-location"
                hidden
                i18n="@@AriaCarSearchDropoffPostcodeLocation"
                >Dropoff Location</span
              >
            </div>
          </div>
        }
        @if (searchParams.locationType === LocationTypes.Airport) {
          <div class="thirds-block">
            <label
              id="car-search-dropoff-airport-country"
              class="header-label"
              for="car-select-dropoff-country"
              i18n="@@carSearchDropoffCountry"
              >Drop-off country</label
            >
            <div class="flex-row-container">
              <i class="ico-marker combo-box-icon"></i>
              <select
                [(ngModel)]="searchParams.dropoff_country"
                appSelect
                id="car-select-dropoff-country"
                aria-labelledby="car-search-dropoff-airport-country"
              >
                <option disabled value="null" i18n="@@carSearchSelectCountry">
                  Select country
                </option>
                @for (country of searchService.countries; track country) {
                  <option [ngValue]="country.cCode">
                    {{ country.cName }}
                  </option>
                }
              </select>
            </div>
          </div>
          <div class="thirds-block">
            <label
              id="car-search-dropoff-airport-location"
              class="header-label"
              for="car-input-dropoff-location"
              i18n="@@carSearchDropoffLocation"
              >Drop-off location</label
            >
            <div class="flex-row-container">
              <i class="ico-marker combo-box-icon"></i>
              <input
                i18n-placeholder
                placeholder="Enter dropoff location"
                name="dropoff_location-input"
                autocomplete="off"
                type="text"
                id="car-input-dropoff-location"
                appInput
                [(ngModel)]="searchParams.dropoff_location"
                [ngbTypeahead]="dropoffLocations"
                [resultTemplate]="railairtemp"
                [inputFormatter]="formatter_rail_air"
                (ngModelChange)="checkHotelCheckbox()"
                (focus)="focus2$.next($event.target.value)"
                (click)="$event.target.select()"
                (selectItem)="checkHotelCheckbox()"
                aria-labelledby="car-search-dropoff-airport-location"
                (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                (keyup.arrowup)="ensureElementIsScrolledTo($event)"
                [hasError]="hasDropoffError"
              />
            </div>
          </div>
        }
        <div class="thirds-block">
          <div class="flex-row-container">
            <ngbd-datepicker-i18n>
              <div class="flex-column-container two-third">
                <i class="ico-calendar combo-box-icon"></i>
                <label
                  for="car-inbound-date"
                  class="header-label date-label"
                  i18n="@@carSearchDropoffTime"
                  >Drop-off date (DD/MM/YYYY)</label
                >
                <app-datepicker
                  [minDate]="searchParams.minDate"
                  [startDate]="searchParams.ngbDropoffDate || searchParams.minDate"
                  [model]="searchParams.ngbDropoffDate"
                  [from]="searchParams.ngbPickupDate"
                  [to]="searchParams.ngbDropoffDate"
                  (newFrom)="searchParams.ngbPickupDate = $event; checkHotelCheckbox()"
                  (newTo)="searchParams.ngbDropoffDate = $event; checkHotelCheckbox()"
                  [class]="'combo-box'"
                  [componentId]="'car-inbound-date'"
                  (newDate)="searchParams.ngbDropoffDate = $event; checkHotelCheckbox()"
                >
                </app-datepicker>
              </div>
              <div class="flex-column-container one-third">
                <i class="ico-clock combo-box-icon" aria-hidden="true"></i>
                <label
                  id="car-search-dropoff-date"
                  i18n="@@carSearchDropoffDate"
                  class="header-label"
                  for="car-select-dropoff-time"
                  >Drop-off time</label
                >
                <select
                  id="car-select-dropoff-time"
                  appSelect
                  [(ngModel)]="searchParams.dropoffTime"
                >
                  @for (time of filterTimeArray(searchParams.timeArray); track time) {
                    <option [ngValue]="time.value">
                      {{ time.display }}
                    </option>
                  }
                </select>
              </div>
            </ngbd-datepicker-i18n>
          </div>
        </div>
      </div>
      @if (!hideCarHireOptions()) {
        <div class="flex-column-container">
          <label class="header-label" i18n="@@carSearchOptions">Options</label>
          <div class="fifth-container">
            @if (searchParams.locationType === LocationTypes.Airport) {
              <div class="fifth-block">
                <label
                  id="car-search-option-vendor"
                  class="header-label"
                  i18n="@@carSearchVendor"
                  for="car-select-vendor"
                  >Vendor</label
                >
                <select
                  appSelect
                  [noIcon]="true"
                  [(ngModel)]="searchParams.chosenVendor"
                  aria-labelledby="car-search-option-vendor"
                  (ngModelChange)="updateLocation()"
                  id="car-select-vendor"
                >
                  @for (vendor of searchParams.vendors; track vendor) {
                    <option [value]="vendor.code">
                      {{ vendor.name | translate }}
                    </option>
                  }
                </select>
              </div>
            }
            <div class="fifth-block">
              <label
                id="car-search-option-car-class"
                class="header-label"
                i18n="@@carSearchCarClass"
                for="car-class-select"
                >Car class</label
              >
              <select
                appSelect
                [noIcon]="true"
                id="car-class-select"
                [(ngModel)]="searchParams.carClass"
                aria-labelledby="car-search-option-car-class"
              >
                <option value="" i18n="@@CarHireCarClassAny">Any</option>
                @for (item of searchParams.getCarClasses() | async; track item) {
                  <option [value]="item.key">
                    {{ item.name | translate }}
                  </option>
                }
              </select>
            </div>
            <div class="fifth-block">
              <label
                id="car-search-option-car-type"
                class="header-label"
                i18n="@@carSearchCarType"
                for="car-type-select"
                >Car type</label
              >
              <select
                appSelect
                [noIcon]="true"
                [(ngModel)]="searchParams.carType"
                aria-labelledby="car-search-option-car-type"
                id="car-type-select"
              >
                <option value="" i18n="@@CarHireCarTypeAny" selected="selected">Any</option>
                @for (item of searchParams.carTypeCodes; track item) {
                  <option [value]="item[2]">
                    {{ item[1] | translate }}
                  </option>
                }
              </select>
            </div>
            <div class="fifth-block">
              <label
                id="car-search-option-transmission"
                class="header-label"
                i18n="@@carSearchTransmission"
                for="car-transmission-select"
                >Transmission</label
              >
              <select
                appSelect
                [noIcon]="true"
                [(ngModel)]="searchParams.transmission"
                (ngModelChange)="updateAircon($event)"
                aria-labelledby="car-search-option-transmission"
                id="car-transmission-select"
              >
                <option value="" i18n="@@CarHireCarTransmission" selected="selected">Any</option>
                @for (item of searchParams.carTransmissionCodes; track item) {
                  <option [value]="removeExtra(item[2])">
                    {{ item[1] | translate }}
                  </option>
                }
              </select>
            </div>
            <div class="fifth-block">
              <label
                id="car-search-option-aircon"
                class="header-label"
                i18n="@@carSearchAirConditioning"
                for="car-conditioning-select"
                >Air conditioning</label
              >
              <select
                appSelect
                [noIcon]="true"
                [(ngModel)]="searchParams.airCon"
                aria-labelledby="car-search-option-aircon"
                id="car-conditioning-select"
              >
                @for (item of searchParams.carAirConditionTypes; track item) {
                  <option
                    [disabled]="item[2] === null && searchParams.transmission"
                    [ngValue]="item[2]"
                  >
                    {{ item[1] | translate }}
                  </option>
                }
              </select>
            </div>
            <div class="fifth-block">
              <div class="flex-row-container">
                <label
                  id="car-search-option-Milage"
                  class="header-label"
                  i18n="@@carSearchMilage"
                  for="carSearchMilage"
                  >Estimated mileage</label
                >
                @if (!usingKm) {
                  <section (mouseleave)="tt.close()" class="container">
                    <button
                      #ttBtn
                      type="button"
                      class="accessible-tooltip-trigger ico ico-info-circle"
                      i18n-ngbTooltip
                      ngbTooltip="To calculate your carbon consumption and/or allowance, please enter the estimated number of miles you plan to do during your trip. If you leave this field blank, the system will automatically default to 100 estimated miles per day."
                      triggers="manual"
                      #tt="ngbTooltip"
                      (mouseenter)="tt.open()"
                      (focus)="tt.open()"
                      (blur)="tt.close()"
                      (click)="tt.toggle()"
                      (hidden)="ttBtn.setAttribute('aria-describedby', 'estimated-miles-tooltip')"
                      aria-label="Estimated miles information"
                      aria-describedby="estimated-miles-tooltip"
                    ></button>
                    <div class="visuallyhidden" id="estimated-miles-tooltip" role="tooltip">
                      To calculate your carbon consumption and/or allowance, please enter the
                      estimated number of miles you plan to do during your trip. If you leave this
                      field blank, the system will automatically default to 100 estimated miles per
                      day.
                    </div>
                  </section>
                }
                @if (usingKm) {
                  <section (mouseleave)="ttkm.close()" class="container">
                    <button
                      #ttkmBtn
                      type="button"
                      class="accessible-tooltip-trigger ico ico-info-circle"
                      i18n-ngbTooltip
                      ngbTooltip="To calculate your carbon consumption and/or allowance, please enter the estimated number of km you plan to do during your trip. If you leave this field blank, the system will automatically default to 100 estimated km per day."
                      triggers="manual"
                      #ttkm="ngbTooltip"
                      (mouseenter)="ttkm.open()"
                      (focus)="ttkm.open()"
                      (blur)="ttkm.close()"
                      (click)="ttkm.toggle()"
                      (hidden)="ttkmBtn.setAttribute('aria-describedby', 'estimated-km-tooltip')"
                      aria-label="Estimated kilometres information"
                      aria-describedby="estimated-km-tooltip"
                    ></button>
                    <div class="visuallyhidden" id="estimated-km-tooltip" role="tooltip">
                      To calculate your carbon consumption and/or allowance, please enter the
                      estimated number of km you plan to do during your trip. If you leave this
                      field blank, the system will automatically default to 100 estimated km per
                      day.
                    </div>
                  </section>
                }
              </div>
              <input
                type="number"
                appInput
                [noIcon]="true"
                [(ngModel)]="searchParams.estimatedMileage"
                min="0"
                step="1"
                aria-labelledby="car-search-option-mileage"
                id="car-input-select-mileage"
                placeholder="Enter est. mileage"
                i18n-placeholder
              />
            </div>
          </div>
        </div>
      }
      @if (
        displayHotelCheck && toggleHotelSearchRequested.observed && services[ServiceType.Hotel]
      ) {
        <div class="flex-row-container hotel-check">
          <button
            appButton="large"
            color="primary"
            [attr.aria-pressed]="hotelsearchRequested"
            id="car-checkbox-hotel-{{ hotelsearchRequested ? 'remove' : 'add' }}"
            (click)="toggleHotelCheckbox()"
          >
            @if (!hotelsearchRequested) {
              <span i18n="@@carAddHotelcheck"> Add Hotel </span>
            }
            @if (hotelsearchRequested) {
              <span i18n="@@carRemoveHotelcheck"> Remove Hotel </span>
            }
          </button>
        </div>
      }
    } @else {
      <app-favorite-items [serviceType]="ServiceType.Car"> </app-favorite-items>
    }
  </div>

  @if (hotelsearchRequested && toggleHotelSearchRequested.observed) {
    <h2 class="hotel-header">Hotel</h2>
    <app-hotel-search></app-hotel-search>
  }
</div>
<app-car-loading-screen></app-car-loading-screen>
